import { type TFunction } from "i18next";
import { z } from "zod";

export const getApprovalDrawerSchema = (t: TFunction) =>
  z.object({
    externalNotes: z
      .string()
      .max(1000, t("form-validation.max-length", { label: t("form-validation.field"), max: 1000 }))
      .optional(),
    internalNotes: z
      .string()
      .max(1000, t("form-validation.max-length", { label: t("form-validation.field"), max: 1000 }))
      .optional(),
  });

export type DrawerSchema = z.infer<ReturnType<typeof getApprovalDrawerSchema>>;
